export default "__VITE_ASSET__804217b7__"